import { MantineThemeOverride } from '@mantine/core'
import { routexAmber, routexGold, routexGray, RoutexTokens } from './palette'

const T = RoutexTokens.dark

/**
 * Tema escuro do RouteX Admin.
 *
 * Mesma paleta âmbar do tema claro; o que muda são as superfícies — fundo quase preto
 * amarronzado, cartões em marrom profundo. Os halos do fundo ficam mais discretos, porque sobre
 * escuro o mesmo alfa se destaca mais.
 */
export const AppThemeDark: MantineThemeOverride = {
  primaryColor: 'appPrimary',
  primaryShade: 6,
  colors: {
    appPrimary: routexAmber,
    appAccent: routexGold,
    appGray: routexGray,
    routexAmber,
    routexGold,
  },
  defaultRadius: 'lg',
  radius: {
    xs: '6px',
    sm: '9px',
    md: '11px',
    lg: '16px',
    xl: '22px',
  },
  fontFamily: 'Inter, system-ui, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: '700',
  },
  shadows: {
    xs: '0 4px 14px rgba(0,0,0,.14)',
    sm: '0 6px 20px rgba(0,0,0,.20)',
    md: T.shadow,
    lg: '0 16px 44px rgba(0,0,0,.34)',
    xl: '0 22px 60px rgba(0,0,0,.40)',
  },
  components: {
    AppShell: {
      styles: {
        navbar: {
          border: 'none',
          backgroundImage: RoutexTokens.sidebarGradient,
          backgroundColor: RoutexTokens.espresso950,
        },
        header: {
          borderBottom: `1px solid ${T.border}`,
          backgroundColor: T.surface,
        },
        main: {
          backgroundColor: T.bg,
          backgroundImage:
            'radial-gradient(circle at 85% 8%, rgba(245,158,11,.07), transparent 26%),' +
            'radial-gradient(circle at 15% 88%, rgba(180,83,9,.05), transparent 28%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: 'md',
        radius: 'lg',
        withBorder: true,
      },
      styles: {
        root: {
          backgroundColor: T.surface,
          borderColor: T.border,
          color: T.text,
        },
      },
    },
    Paper: {
      styles: {
        root: {
          backgroundColor: T.surface,
          borderColor: T.border,
          color: T.text,
        },
      },
    },
    Button: {
      defaultProps: {
        radius: 'sm',
      },
    },
    Badge: {
      styles: {
        root: {
          textTransform: 'none',
        },
      },
    },
    Table: {
      styles: {
        th: {
          color: T.muted,
          fontWeight: 700,
          backgroundColor: T.surface2,
        },
      },
    },
    Code: {
      styles: {
        root: {
          backgroundColor: T.surface3,
          color: T.text,
        },
      },
    },
    Tooltip: {
      styles: {
        tooltip: {
          fontWeight: '500',
        },
      },
    },
  },
}
